/* Shiny Leaf — floating widget placement (see sl-float.css)
   - html.sl-chat-open while the ElevenLabs chat panel is open, so it opens at full size
   - on product pages: html.sl-pdp + one of sl-f-top / sl-f-hide / sl-f-low, from the scroll position */
(function () {
  if (window.__slFloatJs) return; window.__slFloatJs = true;
  var html = document.documentElement, tries = 0;

  function watch(host) {
    var sr = host.shadowRoot; if (!sr) return false;
    function sync() { html.classList.toggle('sl-chat-open', !!sr.querySelector('.rounded-sheet') && !sr.querySelector('.rounded-compact-sheet')); }
    new MutationObserver(sync).observe(sr, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    sync();
    return true;
  }
  (function find() {
    var host = document.querySelector('elevenlabs-convai');
    if (host && watch(host)) return;
    if (++tries < 40) setTimeout(find, 500);
  })();

  function pdp() {
    var forms = document.querySelectorAll('.slp-form');
    if (!forms.length) return;
    html.classList.add('sl-pdp');
    var state = '', ticking = false;
    function set(s) { if (s === state) return; if (state) html.classList.remove(state); html.classList.add(s); state = s; }
    function check() {
      ticking = false;
      if ((window.scrollY || window.pageYOffset) < 60) return set('sl-f-top');
      var vh = window.innerHeight, onScreen = false;
      for (var i = 0; i < forms.length; i++) {
        var r = forms[i].getBoundingClientRect();
        if (r.height && r.bottom > 0 && r.top < vh) { onScreen = true; break; }
      }
      set(onScreen ? 'sl-f-hide' : 'sl-f-low');
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(check); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pdp); else pdp();
})();
